import React, {useState, useCallback, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { View } from 'react-native';
import { CREATE_COMMISSION } from './queries';
import { ButtonContainer } from 'app/src/elements';
import { COMMISSION_TYPE_OPTIONS } from '.';

const NewCommission = ({setShowModal, refetch}) => {
  const [submitting, setSubmitting] = useState();
  const [createCommission] = useMutation(CREATE_COMMISSION, {
    onCompleted: () => {
      if(refetch) {
        refetch();
      }
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    if(input['salesLimit']) {
      input = {...input, salesLimit: parseInt(input['salesLimit'])}
    }
    createCommission({ variables: input });
  });

  const { control, handleSubmit, watch, register, setValue,
    formState: { errors }
  } = useForm({
    defaultValues: {
      name: '',
      type: '',
      salesLimit: 0,
      hasSalesLimit: false,
      amount: ''
    }
  });

  const watchType = watch('type');
  const watchHasSalesLimit = watch('hasSalesLimit');

  useEffect(() => {
    if (watchType === 'Flat Payment') {
      setValue('salesLimit', 0);
      setValue('hasSalesLimit', false);
    }
  }, [watchType])

  return (
    <View>
      {/* <SubNav /> */}
      {submitting ?
        <DataState.Loading /> :
        <View>
          <Input.Text
            label="Name:"
            name="name"
            control={control}
            errors={errors}
            {...register("name", {
              required: "Required",
            })}
          />
          <Input.Picker
            label="Type:"
            name="type"
            options={COMMISSION_TYPE_OPTIONS.map(type => {
              return { value: type, label: type }
            })}
            control={control}
            errors={errors}
            {...register("type", {
              required: "Required",
            })}
          />

          {getSalesLimitInputs()}

          <Input.Number
            label={getAmountLabel()}
            name="amount"
            control={control}
            errors={errors}
            {...register("amount", {
              required: "Required",
              validate: {
                matchPattern: (v) =>
                  /\d{1,10}(\.{1}\d{1,2}){0,1}?$/.test(v) ||
                  "Please use number only without commas",
              },
            })}
          />
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Create Commission" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )

  function getSalesLimitInputs() {
    if(watchType !== 'Flat Payment') {
      return (
        <View>
          <Input.Checkbox
            label="Has Sales Limit?"
            name="hasSalesLimit"
            checked={watchHasSalesLimit}
            control={control}
            errors={errors}
          />
          {watchHasSalesLimit &&
            <Input.Number
              label="Sales Limit:"
              name="salesLimit"
              control={control}
              errors={errors}
              {...register("salesLimit", {
                validate: {
                  matchPattern: (v) =>
                    /\d{1,10}(\.{1}\d{1,2}){0,1}?$/.test(v) ||
                    "Please use number only without commas",
                },
              })}
            />
          }
        </View>
      )
    }
  }

  function getAmountLabel() {
    if(watchType === 'Flat Payment') {
      return "Dollar Amount Paid for Each Sale:"
    }else if(watchType === '% of sales') {
      return "Percentage Amount (ie: enter 5 for 5%):"
    }else if(watchType === '% of profit') {
      return "Percentage Amount (ie: enter 5 for 5%):"
    }else {
      return "Amount:"
    }
  }
}

export default NewCommission;
